import api from "../../api/axios";

export const getAllRides = async (params) => {
  const response = await api.get("/rides", { params });
  return response.data;
};

export const updateRide = async (id, data) => {
  const response = await api.put(`/rides/${id}`, data);
  return response.data;
};
